
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  Code,
  ColorPalette,
  Preview,
} from "@lighting-beetle/lighter-styleguide";
export const scope = "react";
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  scope
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Lighter components 😍 outside styleguide`}</h1>
    <h2>{`ColorPalette`}</h2>
    <ColorPalette name="primary" color="#ff5722" mdxType="ColorPalette" />
    <h2>{`Code`}</h2>
    <Code mdxType="Code">{"This is <span>html</span> string"}</Code>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;